module.exports = __webpack_public_path__ + "static/bountycontestctbtn-4fe7d281e4eecd157f245bda33144be2.png";